<template>

    <div class="ES-xcx-info top10">
    <span class="ES-notice right20">建议尺寸：100px * 100px</span>
        <wcbutton 
        :option="{title:'添加分类'}" 
        @finish="(val)=> {
            if(catelists.length==limit) {
                $notice({title:'消息提示',message:'添加分类数量不能超过'+limit,type:'warning'});
                return false;
            }else {
                var datainfo={};
                for(var i in cateinfo) datainfo[i]=cateinfo[i];
                catelists.push(datainfo);
            }
        }"
        />
    </div>
    <div class="TTL-table top30" :ref="objloading">
    <el-table :data="catelists" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column label="分类图" align="center">
            <template #default="scope">
            <wcupload :value="scope.row.thumb" :option="{size:'middle', phototype:'system'}" class="uploadImg"  
                @finish="(val)=> {
                    scope.row.thumb=val.url;
                    Updatecate(scope.$index);
                }"
            />
            </template>
        </el-table-column>
        <el-table-column label="名称" align="center">
            <template #default="scope">
            <wcselect :option="{placeholder:'请选择分类',ischange:true,width:'150px',filterable:true}" 
                class="uploadImg" 
                :value="scope.row.infoid"
                :list="childcatelists"
                @finish="(val)=> {
                    scope.row.infoid=val.value;
                    scope.row.name=val.valuename;
                    scope.row.thumb=val.thumb;
                    Updatecate(scope.$index);
                }"
            />
            </template>
        </el-table-column>
        <el-table-column label="排序" align="center">
            <template #default="scope">
            <wcinput :option="{placeholder:'排序',type:'input',width:'80px',ischange:true,isinput:true}" 
                class="uploadImg"
                :value="scope.row.sort"
                @finish="(val) => {
                    if(val.type=='change') {
                        scope.row.sort=val.value;
                        Updatecate(scope.$index);
                    }
                }"
            />
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
            <template #default="scope">
                <wcbutton :option="{title:'删除',type:'del'}" 
                    @finish="(val)=> {
                        var id=scope.row.id;
                        catelists.splice(scope.$index,1);
                        DelCate(id);
                    }"
                />
            </template>
        </el-table-column>
    </el-table>
    </div>

</template>

<script>
import INTERFACE_XCX from '@/Interface/Es/xcx'; //小程序首页显示
export default {
    components:{INTERFACE_XCX},

    data() {
        return {
            objloading:'xcxbanner',
            limit:10,
            cateinfo: {id:'',name:'',infoid:'',thumb:'',sort:0},
            catelists: [],
            childcatelists:[],
        }
    },

    mounted() {
        this.GetChildcates(); //获取二级分类信息
        this.CateInfo();
    },

    methods: {
        
        //获取分类信息
        CateInfo() {
            INTERFACE_XCX.GET_CATE_LIST().then((res) => {
                 if(res.status > 0) return false;
                 this.catelists=res.data;
            });
        },

        /** 更新banner信息 **/
        Updatecate(index) {
            var cateinfo=this.catelists[index];
            var METHOD=cateinfo.id > 0 ? 'UPDATE_CATE' : 'ADD_CATE';
            INTERFACE_XCX[METHOD](cateinfo).then((res) => {
                 if(res.status > 0) return false;
                 if(METHOD=='ADD_CATE') cateinfo.id=res.data.id;
                 this.catelists=this.$method.DATA_SORT(this.catelists,{sort:'desc'});
                 this.$emit('finish',{data:this.catelists});
            });
        },

        /** 删除广告 **/
        DelCate(id) {
            INTERFACE_XCX.DEL_CATE({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.catelists=this.$method.DATA_SORT(this.catelists,{sort:'desc'});
                 this.$emit('finish',{data:this.catelists});
            });
        },

        //获取二级分类信息
        GetChildcates() {
            this.$method.GET_CATES_CHILD(true).then((res) => {this.childcatelists=res;console.log(res)});
        },

    },
    
}
</script>
<style scoped>
.ES-xcx-info {display: inline-flex;align-items: center;width:100%;justify-content: flex-end;}
.uploadImg {display:inline-flex;justify-content:center;align-items: center;}
.ES-notice {font-size:12px;color:#333333;margin-top:20px;}
::v-deep(.TTL-input .el-input__inner) {text-align: center;}
::v-deep(.TTL-select .el-input__inner) {text-align: center;}
</style>